import { render, staticRenderFns } from "./Thank-You.vue?vue&type=template&id=45c9cef7&"
import script from "./Thank-You.vue?vue&type=script&lang=js&"
export * from "./Thank-You.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports